<div class="text-white p-4 flex items-center justify-center rounded shadow-2xl"
  [class.bg-green-600]="isSuccess" [class.bg-red-500]="isError" [class.bg-blue-600]="isInfo" [class.bg-yellow-700]="isWarning">
  <div class="flex-1">
    <h2 class="font-bold text-lg">{{ alert.title }}</h2>
    <p>{{ alert.description }}</p>
  </div>
  <svg (click)="alertService.cleanAlert()" class="stroke-current fill-current w-8 cursor-pointer" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
    <path d="m289.94 256 95-95A24 24 0 0 0 351 127l-95 95-95-95a24 24 0 0 0-34 34l95 95-95 95a24 24 0 1 0 34 34l95-95 95 95a24 24 0 0 0 34-34Z"/>
  </svg>
</div>
